import { connect } from 'react-redux';

import { IState } from '../../store';
import { ISimilarOffersLinkProps, SimilarOffersLink } from './index';

export function mapStateToProps(state: IState): ISimilarOffersLinkProps {
  const {
    offerData: { offer, kp },
  } = state;
  const { similarOffersCount, similarOffersLink } = offer;

  return {
    similarOffersCount,
    similarOffersLink,
    kpId: kp && kp.id,
  };
}

export const SimilarOffersLinkContainer = connect<ISimilarOffersLinkProps>(mapStateToProps)(SimilarOffersLink);
